import { z } from "zod";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const contactMemberSchema = z.object({
	firstName: z.string().nullable(),
	title: z.string().nullable(),
	lastName: z.string().min(1),
	email: z.email().nullish(),
	phone: z.string().nullish(),
	contactMemberTypeId: z.uuid(),
	contactId: ZodStringNullable,
	authorizations: z.array(z.uuid()).default([]),
});

export type ContactMemberSchema = z.infer<typeof contactMemberSchema>;
